////////////////////////////////////////////////////////////////////////////////
// Country
////////////////////////////////////////////////////////////////////////////////

class Country extends Pages {

	// ===========================================================================
	// Constructor
	// ===========================================================================

	constructor(entry) {
		super(entry)

		// If a county page is the first page loaded, the WhereWeOperate class
		// won't have been constructed yet. This is a one-time-only thing.
		if ( !whereWeOperate ) {
			whereWeOperate = new WhereWeOperate(entry)
			if ($('#chartdiv').is(':empty')){
				whereWeOperate.buildMap();
			}
		}
	}

	// ===========================================================================
	// Initialisation
	// ===========================================================================

	/**
	 * The entry needs to be passed in here so that this class can update the data
	 * used for this class instance. Otherwise it will always stay the same no matter
	 * what page you go to next.
	 * @param  {Object} entry
	 */

	init(entry) {
		this.update.entry(entry)
		if ( this.debug ) { console.log(`This is the init method for the "${this.entry.title}" country page.`) }
	}

	// ===========================================================================
	// Load In
	// ===========================================================================

	/**
	 * This is run when navigating to a country page
	 * @param  {Object}   content jQueryified object with mark up blocks.
	 * @param  {Function} done    The callback to tell the historyAPI that the page has finished loading
	 */

	in(content, done) {

		console.log(`Zoom map to ${this.entry.title}`)

		// CustomProperties.set('theme', content.filter('header').find('h1').attr('data-theme'), body)

		document.body.classList.add('where-we-operate')

		// Zoom to specific country based on the entries country code.
		whereWeOperate.zoomToCountry(this.entry);

		// Replace this for a special transition in for this country page
		page.in(content, done)

	}

	// ===========================================================================
	// Load Out
	// ===========================================================================

	/**
	 * This is run when navigating awat from a country page
	 * @param  {Object}   content jQueryified object with mark up blocks.
	 * @param  {Function} done    The callback to tell the historyAPI that the page has finished loading
	 */

	out(content, done) {

		// CustomProperties.remove('theme', body)

		// Replace this for a special transition out for this country page
    page.out(content, done)

	}

}
